import { Component, Input, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {
  @Input() isLoggedIn: boolean = false;
  constructor(private authService: MsalService, private router: Router) { }
  ngOnInit() {
    this.isLoggedIn = this.authService.instance.getAllAccounts().length > 0;
    if (this.isLoggedIn) {
      this.router.navigate(['home']);
    }
  }

  public login() {
    this.authService.loginRedirect({
      scopes: ['openid', 'profile', 'email', 'offline_access'],
    });
  }
}
